import { forwardRef } from 'react';
// eslint-disable-next-line import/no-namespace
import * as Carousel from '@mweb/zappos-ui/Carousel';

import { cn } from 'helpers/classnames';
import type { ProductCarouselProps } from 'components/common/ProductCarousel/ProductCarousel.types';
import { backButton, forwardButton, item, root } from 'components/common/ProductCarousel/ProductCarousel.classes';
import { CarouselProvider } from 'components/common/ProductCarousel/ProductCarousel.context';
import { getTestId } from 'utils/testing';
import CaretLeftIcon from 'components/common/IconsV2/CaretLeftIcon';
import CaretRightIcon from 'components/common/IconsV2/CaretRightIcon';

export const ProductCarousel = forwardRef<HTMLDivElement, React.ComponentProps<typeof Carousel.Root> & ProductCarouselProps>((props, ref) => {
  const { options = {}, overrides = {}, slides, testId = '', backButtonOnClick, forwardButtonOnClick, ...rest } = props;

  return (
    <CarouselProvider>
      <Carousel.Root ref={ref} options={options} className={cn(root, overrides.root)} data-test-id={getTestId(testId, 'root')} {...rest}>
        <Carousel.Viewport className={cn(overrides.viewport)} data-test-id={getTestId(testId, 'viewport')}>
          <Carousel.Items className={cn(overrides.items)} data-test-id={getTestId(testId, 'items')}>
            {slides.map((slide, i) => (
              <Carousel.Item key={i} className={cn(item, overrides.item)} data-test-id={getTestId(testId, `item-${i + 1}`)}>
                {slide}
              </Carousel.Item>
            ))}
          </Carousel.Items>

          <Carousel.Back className={cn(backButton, overrides.backButton)} data-test-id={getTestId(testId, 'back')} onClick={backButtonOnClick}>
            <CaretLeftIcon size={32} />
          </Carousel.Back>

          <Carousel.Forward
            className={cn(forwardButton, overrides.forwardButton)}
            data-test-id={getTestId(testId, 'forward')}
            onClick={forwardButtonOnClick}
          >
            <CaretRightIcon size={32} />
          </Carousel.Forward>
        </Carousel.Viewport>
      </Carousel.Root>
    </CarouselProvider>
  );
});
